module.exports = __webpack_public_path__ + "static/media/5.21af0c28.svg";